import React from 'react';
import Button from '../UI/Button';
import Dev from '../assets/icons/Lev.jpg';
import SocialIcons from '../UI/SocialIcons';
import data from '../data/hero.json';

export default function Hero() {
  return (
    <section data-aos='fade-in' className='text-gray-300 body-font bg-gray-900 border-b border-gray-700 pt-8'>
      <div className='container mx-auto flex px-6 py-24 md:flex-row flex-col items-center'>
        <div className='lg:flex-grow md:w-1/2 lg:px-12 md:px-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center'>
          <h1 className='title-font sm:text-5xl text-4xl mb-4 font-medium text-white'>
            <span role='img' aria-label='Waving Hand: Dark Skin Tone'>
              {' '}
              👋 &nbsp;
            </span>
            {data.h1}
          </h1>
          <h2 className='sm:text-2xl text-1xl mb-8 leading-relaxed'>
            {data.h2}
          </h2>

          <div className='flex justify-center'>
            <Button
              name={'CONTACT'}
              type={'blue'}
              action={'mailto:polshkov.lv@gmail.com'}
              color={'blue'}
            />
          </div>
        </div>
        <div className='lg:max-w-lg lg:w-full md:w-1/2 w-5/6 object-cover object-center rounded-full'>
          <img className='rounded-3xl' src={Dev} alt='' />
        </div>
      </div>
    </section>
  );
}
